import { render, staticRenderFns } from "./ProjectEventTypeDetailsForm.vue?vue&type=template&id=2f24e89c&scoped=true&"
import script from "./ProjectEventTypeDetailsForm.vue?vue&type=script&lang=js&"
export * from "./ProjectEventTypeDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEventTypeDetailsForm.vue?vue&type=style&index=0&id=2f24e89c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f24e89c",
  null
  
)

export default component.exports